/* eslint-disable jsx-a11y/anchor-is-valid */
// import clsx from 'clsx'
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {Providence} from '../../core/_models'

type Props = {
  Providence: Providence
}

const ProvidenceStatus: FC<Props> = ({Providence}) => {
  const intl = useIntl()
  return (
    <div className='d-flex text-center justify-content-center'>
      <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-primary mb-1'>
          {Providence.status === 'not_started' && (
            <div className='badge badge-primary  fw-bolder fs-9'>
              {intl.formatMessage({id: 'COMMON.NOT_STARTED'})}
            </div>
          )}
          {Providence.status === 'in_progress' && (
            <div className='badge badge-warning  fw-bolder fs-9'>
              {intl.formatMessage({id: 'COMMON.IN_PROGRESS'})}
            </div>
          )}
          {Providence.status === 'expired' && (
            <div className='badge badge-danger  fw-bolder fs-9'>
              {intl.formatMessage({id: 'COMMON.EXPIRED'})}
            </div>
          )}
          {Providence.status === 'canceled' && (
            <div className='badge badge-dark  fw-bolder fs-9'>
              {intl.formatMessage({id: 'COMMON.CANCELED'})}
            </div>
          )}
          {Providence.status === 'done' && (
            <div className='badge  badge-success  fw-bolder fs-9'>
              {intl.formatMessage({id: 'COMMON.COMPLETED'})}
            </div>
          )}
        </a>
      </div>
    </div>
  )
}

export {ProvidenceStatus}
